import { useMediaQuery, useTheme } from '@mui/system'
import React from 'react'
import { ContractStateProps, ExtensionCategory, ExtensionType } from '../../types'
import DetailsModal from './DetailsModal'
import DetailsDrawer from './DetailsDrawer'

interface Props {
  extensionType: ExtensionType
  descriptions: string[]
  headerContent: React.ReactElement
  bodyContent?: React.ReactElement
  footerContent: React.ReactElement
  onClose: () => void
  place: number
  open: boolean
  category: ExtensionCategory
  contractStateProps?: ContractStateProps
  linkHref?: string
  onLinkClick?: () => void
}

/**
 * Component to display detailed extension information via drawer or modal based on the breakpoint.
 */
const DetailsViewWrapper: React.FC<Props> = ({
  extensionType,
  descriptions,
  headerContent,
  bodyContent,
  footerContent,
  onClose,
  open,
  place,
  category,
  contractStateProps,
  linkHref,
  onLinkClick,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (isMobile) {
    return (
      <DetailsDrawer
        extensionType={extensionType}
        descriptions={descriptions}
        headerContent={headerContent}
        bodyContent={bodyContent}
        footerContent={footerContent}
        onClose={onClose}
        open={open}
        category={category}
        contractStateProps={contractStateProps}
        linkHref={linkHref}
        onLinkClick={onLinkClick}
      />
    )
  }

  return (
    <DetailsModal
      onClose={onClose}
      descriptions={descriptions}
      headerContent={headerContent}
      bodyContent={bodyContent}
      footerContent={footerContent}
      extensionType={extensionType}
      open={open}
      place={place}
      category={category}
      contractStateProps={contractStateProps}
      linkHref={linkHref}
      onLinkClick={onLinkClick}
    />
  )
}

export default DetailsViewWrapper
